import { Icon } from "@/components/common/Icon";
import { Button } from "@/components/common";

import { WS_STEPS, type WsForm, type WsStepId } from "./types";

interface Props {
  form: WsForm;
  completed: Record<string, boolean>;
  onResume: (id: WsStepId) => void;
  onExit: () => void;
}

export function WsSuccess({ form, completed, onResume, onExit }: Props) {
  const pendingSteps = WS_STEPS.filter((s) => !completed[s.id]);
  const allDone = pendingSteps.length === 0;

  if (allDone) {
    return (
      <div className="onb-success">
        <div className="onb-success-icon">
          <Icon name="check" size={36} stroke={2.5} />
        </div>
        <h1 className="onb-step-title is-center">Tudo pronto!</h1>
        <p className="onb-step-sub is-center">
          <strong className="onb-strong-fg1">
            {form.nomeWorkspace || "Seu workspace"}
          </strong>{" "}
          está configurado e operando. Você pode começar a usar agora mesmo.
        </p>
        <div className="onb-success-foot">
          <Button variant="primary" iconLeft="arrow-up-right" onClick={onExit}>
            Ir para o dashboard
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className="onb-success">
      <div className="onb-success-icon">
        <Icon name="check" size={36} stroke={2.5} />
      </div>
      <h1 className="onb-step-title is-center">Workspace criado!</h1>
      <p className="onb-step-sub is-center">
        <strong className="onb-strong-fg1">
          {form.nomeWorkspace || "Seu workspace"}
        </strong>{" "}
        está pronto. Você já pode usar, mas existem etapas pendentes que
        destravam mais funcionalidades.
      </p>

      <div className="onb-success-checklist">
        <div className="onb-success-checklist-head">
          <div>
            <div className="onb-section-title onb-success-checklist-title">
              Pendências
            </div>
            <div className="onb-section-sub">
              Você pode completar agora ou depois nas configurações do
              workspace.
            </div>
          </div>
          <span className="tag-chip onb-success-checklist-tag">
            {pendingSteps.length} restantes
          </span>
        </div>

        <div className="onb-success-list">
          {WS_STEPS.filter((s) => s.id !== "workspace").map((s) => {
            const isCompleted = !!completed[s.id];
            return (
              <div
                key={s.id}
                className={`onb-success-item ${isCompleted ? "is-completed" : ""}`}
              >
                <span
                  className={`onb-success-bullet ${isCompleted ? "ok" : "pending"}`}
                >
                  {isCompleted ? (
                    <Icon name="check" size={13} stroke={3} />
                  ) : (
                    <Icon name={s.icon} size={13} />
                  )}
                </span>
                <div className="onb-success-item-body">
                  <div className="onb-success-item-title">{s.label}</div>
                  <div className="onb-success-item-sub">
                    {isCompleted
                      ? "Concluída"
                      : s.id === "config"
                        ? "Cor, fuso e canais de notificação. Tudo opcional."
                        : s.id === "equipe"
                          ? "Convide outras pessoas pra operar com você."
                          : "Opcional"}
                  </div>
                </div>
                {!isCompleted && (
                  <Button
                    variant="ghost"
                    size="sm"
                    iconRight="arrow-up-right"
                    onClick={() => onResume(s.id)}
                  >
                    Continuar
                  </Button>
                )}
              </div>
            );
          })}
        </div>
      </div>

      <div className="onb-success-foot">
        <Button variant="ghost" onClick={onExit}>
          Ir para o dashboard
        </Button>
        <Button
          variant="primary"
          iconRight="arrow-up-right"
          onClick={() => onResume(pendingSteps[0]?.id || "config")}
        >
          Continuar configurando
        </Button>
      </div>
    </div>
  );
}
